import { zonedTimeToUtc, utcToZonedTime } from 'date-fns-tz'

export default {
  toLocal: (date) => (date ? zonedTimeToUtc(date, 'UTC') : date),
  toUTC: (date) => (date ? utcToZonedTime(date, 'UTC') : date),
}
